import { useState, useEffect, useCallback } from 'react'
import useAuthenStore from '../../stores/authen/authenStore'

import useCallApi from '../../utilities/axios'

export type Keyword = {
    keyword: string
    irb: string
    usergroupID: string
}

export type Officer = {
    userID: number
    username: string
    nameTH: string
    nameEN: string
    fullnameEN: string
    fullnameTH: string
    mobilePhone: string
    email: string
    irb: number
    updatedDate: string
    createdDate: string
    title: {
        id: number
        name: Translation
        otherName: Translation
    }
    position: {
        id: number
        name: Translation
        otherName: Translation
    }
    isPhD: boolean
    status: {
        id: number
        name: Translation
    }
    usergroup: {
        id: number
        name: Translation
    }
}

type Translation = {
    th: string
    en: string
}

export type Order = 'desc' | 'asc'

// autoLoad = false สำหรับหน้าที่จะเรียก searchOfficers เองพร้อมเงื่อนไขอยู่แล้ว
// ไม่งั้นจะมีการยิง POST /users/search/officer แบบไม่มีเงื่อนไขไปเพิ่ม
export const useSearchParticipant = (autoLoad = true) => {
    const authenStore = useAuthenStore()
    const [officers, setOfficers] = useState<Officer[]>([])

    const callApi = useCallApi()

    const searchParticipants = useCallback(
        async (values?: Keyword, orderyBy?: Order) => {
            // if (authenStore?.profile?.irb) {
            const { data } = await callApi.axiosPost({
                url: `${process.env.REACT_APP_CU_IRB_API_URL}/users/search/participant`,
                params: { ...values, irb: authenStore.profile.irb, orderyBy },
            })
            setOfficers(data)
            // }
        },
        [authenStore.profile.irb],
    )

    useEffect(() => {
        if (!autoLoad) return
        searchParticipants()
    }, [searchParticipants, autoLoad])

    return {
        officers,
        setOfficers,
        searchParticipants,
    }
}
